import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';

interface ChainNode {
  icon: string;
  title: string;
  desc: string;
}

interface Note {
  icon: string;
  title: string;
  desc: string;
}

interface AgriTopologyProps {
  data: {
    eyebrow: string;
    title: string;
    subtitle: string;
    chain: ChainNode[];
    notes: Note[];
  };
}

export default function AgriTopology({ data }: AgriTopologyProps) {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <SectionHeading eyebrow={data.eyebrow} title={data.title} subtitle={data.subtitle} />

        {/* 系统拓扑图 */}
        <Reveal className="mt-12">
          <div className="rounded-2xl border border-background-200 bg-background-50 p-4 md:p-6">
            <img
              src="https://static.readdy.ai/image/4482546e014370507f3d90ff31782979/88ea5a96f0243bf89c13eb785ced1aec.png"
              alt="华辉数智智慧农业软硬件系统拓扑图，含云端平台、IoT 物联网连接平台、网络层与终端感知控制层"
              title="智慧农业软硬件系统拓扑图"
              className="w-full h-auto object-contain rounded-xl"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}